import { NrlkAPI } from "./api.js";

export class NrlkTicket {
  constructor(entreprise, token = null) {
    this.api = new NrlkAPI(entreprise, token);
  }

  setEntreprise(entreprise) { this.api.setEntreprise(entreprise); }
  setToken(token) { this.api.setToken(token); }

  async getTicket(idTicket) {
    return this.api.get(`/extranet/ticket/${idTicket}`);
  }

  async getTicketsOuverts() {
    return this.api.get('/extranet/tickets', { statut: 'ouvert' });
  }

  async getTicketsFermes() {
    return this.api.get('/extranet/tickets', { statut: 'ferme' });
  }

  async createTicket(ticket) {
    return this.api.post('/extranet/ticket', ticket);
  }

  async addInterventionsTicket(idTicket, interventions) {
    return this.api.post(`/extranet/ticket/${idTicket}/intervention`, interventions);
  }

  async ouvrirTicket(idTicket) {
    return this.api.put(`/extranet/ticket/${idTicket}/reouvrir`);
  }

  async facturationTicket(idTicket, ticket) {
    return this.api.put(`/extranet/ticket/${idTicket}/fermer`, ticket);
  }

  async updateTicket(idTicket, ticket) {
    return this.api.put(`/extranet/ticket/${idTicket}`, ticket);
  }

  async addFichiersTicket(idTicket, fichiers) {
    return this.api.post(`/extranet/ticket/${idTicket}/fichier`, fichiers);
  }
}
